import ApiClient from './ApiClient';

// Conecta (POST) e reconecta (PATCH /:inbox_id) a caixa do NAVI App.
class NaviappInboxesAPI extends ApiClient {
  constructor() {
    super('naviapp_inboxes', { accountScoped: true });
  }
}

export default new NaviappInboxesAPI();
